import { SERVICES } from "./data";
import { PageFooter, Corner } from "./chrome";

export default function ServicesPage() {
  return (
    <section className="page" data-testid="page-services">
      <div className="grain" />
      <Corner section="IV · Solutions" />
      <div className="page-inner">
        <div className="section-header">
          <div className="eyebrow">What We Offer</div>
          <h2 className="h-title">
            Complete renewable<br /><em>solar solutions.</em>
          </h2>
        </div>

        <div className="services-grid">
          {SERVICES.map((s) => (
            <article className="service-card" key={s.title}>
              <div className="thumb" style={{ backgroundImage: `url(${s.img})` }} />
              <div className="info">
                <div className="tag-label">{s.tag}</div>
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
      <PageFooter num="10" />
    </section>
  );
}
